const resumeData = {
    name: "Anuj Bhusal",
    email: "anujbhusal96@gmail.com",
    phone: "9814421053",
    address: "Maitidevi, Kathmandu",
    profile: "A passionate learner and a computer science student currently pursuing a BSc (Hons) in Computer Science with Artificial Intelligence at Sunway College Kathmandu, affiliated with Birmingham City University, Birmingham. I have a deep interest in AI and data science and enjoy working on innovative solutions through coding and development.",
    education: [
      {
        degree: "BSc (Hons) in Computer Science with Artificial Intelligence",
        institution: "Sunway College Kathmandu",
        duration: "2023 - Present"
      }
    ],
    skills: [
      "Python, JavaScript, React.js",
      "HTML, CSS, Web Designing",
      "Machine Learning, Data Science",
      "VS Code, Google Colab"
    ],
    projects: [
      {
        title: "AI-Based Stock Prediction Tool",
        description: "A web application that predicts stock prices using machine learning algorithms and displays real-time data for Nepali stock market companies."
      },
      {
        title: "Hospital Management System",
        description: "A desktop application built using Python to manage hospital records, patient details, and appointments, integrating a user-friendly interface."
      },
      {
        title: "React-App Portfolio",
        description: "A personal portfolio website built using React.js to showcase my projects, skills, and experiences."
      }
    ],
    hobbies: ["Singing", "Playing sports", "Coding and learning about AI"],
    languages: ["English", "Nepali"],
    contact: {
      linkedin: "linkedin.com/in/anuj-bhusal-22447531b/",
      github: "github.com/Anuj-Bhusal"
    }
  };
  
  export default resumeData;